'use client'

import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { HalfBannerHalfProductTiles } from '@src/SectionRenderer/sections/halfBannerHalfProductTiles'

import {
  buildHalfBannerHalfProductTilesConfig,
  widgetsToProductCards,
} from '../half-banner-half-product-tiles-section-builders'

import type { HalfBannerHalfProductTilesWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

const HalfBannerHalfProductTilesWidgetComponent = (props: PLTypedWidgetProps<HalfBannerHalfProductTilesWidgetData>) => {
  const data = props.data.halfBannerHalfProductTilesData
  // Products arrive as nested widgets (SINGLE_PRODUCT_CARD → productItem), like nested product widgets.
  const productCards = widgetsToProductCards(props.widgets)
  if (!data || !productCards.length) return null

  return <HalfBannerHalfProductTiles sectionConfig={buildHalfBannerHalfProductTilesConfig(data, productCards)} />
}

export const HalfBannerHalfProductTilesWidget: PLTypedWidgetInterface<
  HalfBannerHalfProductTilesWidgetData,
  WidgetType.HALF_BANNER_HALF_PRODUCT_TILES
> = {
  id: WidgetType.HALF_BANNER_HALF_PRODUCT_TILES,
  errorBoundary: PLBaseErrorBoundary,
  render: HalfBannerHalfProductTilesWidgetComponent,
}
